export default __webpack_public_path__ + "static/media/arrowRight.09a60dc9.svg";